module.exports = __webpack_public_path__ + "img/playlist.0baeac1f.svg";